import dayjs from 'dayjs'
import React from 'react'
import { DateCellWrapperProps } from 'react-big-calendar'

import { BigCalendarProps } from '../../BigCalendar'
import { bigCalendarCellWrapperClassNames } from '../../utils/big-calendar.styles'
import {
  isHouseGlobal,
  isHouseIndividual,
} from '../../../../../helpers/assert-house-price-type'
import {
  BigCalendarCellGlobal,
  BigCalendarCellGlobalProps,
} from '../../../../global/components/cell/BigCalendarCellGlobal'
import {
  BigCalendarCellIndividual,
  BigCalendarCellIndividualProps,
} from '../../../../individual/components/cell/BigCalendarCellIndividual'

export const BigCalendarCellWrapper = (
  props: DateCellWrapperProps & Pick<BigCalendarProps, 'house'>,
) => {
  const { children, value: cellDate, house } = props

  const availability =
    house.availabilities?.find(({ date }) =>
      dayjs(date).isSame(dayjs(cellDate), 'day'),
    ) ?? null

  const isPast = dayjs(cellDate).isBefore(dayjs(), 'day')

  return (
    <div
      id={dayjs(cellDate).format('DDMMYYYY')}
      className={`${bigCalendarCellWrapperClassNames({ availability, children, isPast, cellDate })} relative`}
    >
      {isPast ? null : (
        <>
          {isHouseGlobal(house) ? (
            <BigCalendarCellGlobal
              cellDate={cellDate}
              house={house}
              availability={
                availability as BigCalendarCellGlobalProps['availability']
              }
            />
          ) : isHouseIndividual(house) ? (
            <BigCalendarCellIndividual
              cellDate={cellDate}
              house={house}
              availability={
                availability as BigCalendarCellIndividualProps['availability']
              }
            />
          ) : null}
        </>
      )}
    </div>
  )
}
